window.CanteinIngredientProducts = [
  {
    brand: '1st Phorm',
    name: 'Phormula-1',
    flavor: 'Chocolate Milkshake',
    type: 'Whey',
    url: 'https://1stphorm.com/products/phormula-1',
    checked: '2026-10-08',
    note: 'Transcribed from the nutrition label image there.',
    ingredients: 'Whey Protein Isolate, Cocoa (Processed with Alkali), Sunflower Lecithin, Natural Flavor, Salt, Sucralose. Contains: Milk. Manufactured in a facility which processes Milk, Eggs, Soy, and Wheat.',
  },
  {
    brand: 'ALOHA',
    name: 'Organic Plant-Based Protein',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://aloha.com/products/chocolate-protein-powder',
    checked: '2026-10-08',
    ingredients: 'Protein Blend* (Pea Protein*, Brown Rice Protein*, Hemp Seed Protein*, Pumpkin Seed Protein*), Cocoa* (Processed with Alkali), Coconut Sugar*, Blue Agave Inulin*, Natural Flavor*, Xanthan Gum, Monk Fruit Extract*, Sea Salt, Medium Chain Triglycerides (MCT) from Coconut Oil*, Cinnamon*. Contains: Coconut. *Organic',
  },
  {
    brand: 'Amazing Grass',
    name: 'Super Greens + Protein',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://amazinggrass.com/products/super-greens-protein-vanilla',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there. The Supplement Facts panel adds a green food blend (wheat grass, barley grass, alfalfa grass, spinach, spirulina, chlorella, broccoli), vitamin C from acerola and ascorbic acid, and the probiotic Bacillus subtilis DE111; the "Other ingredients" follow.',
    ingredients: 'Organic Wheat Grass, Organic Barley Grass, Organic Alfalfa Grass, Organic Spinach, Organic Spirulina, Organic Chlorella (cracked cell-wall), Organic Broccoli, Acerola Puree, Ascorbic Acid, Bacillus subtilis DE111, Organic Pea Protein, Natural Flavor, Organic Natural Flavor, Salt, Organic Steviol Glycosides.',
  },
  {
    brand: 'Anthony\'s',
    name: 'Pea Protein Powder',
    flavor: 'Unflavored',
    type: 'Plant',
    url: 'https://anthonysgoods.com/products/pea-protein-84-protein-by-anthonys-2lb',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Pea Protein Isolate.',
  },
  {
    brand: 'Ascent',
    name: 'Whey Protein',
    flavor: 'Vanilla Bean',
    type: 'Whey',
    url: 'https://ascentprotein.com/products/vanilla-protein-powder',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Isolate Blend (Native Whey Protein Isolate, Whey Protein Isolate), Whey Protein Concentrate, Natural Flavors, Lecithin, Stevia Leaf Extract, Sea Salt. Contains: Milk And Soy',
  },
  {
    brand: 'Bob\'s Red Mill',
    name: 'Hemp Protein Powder',
    flavor: 'Unflavored',
    type: 'Hemp',
    url: 'https://www.bobsredmill.com/product/hemp-protein-powder',
    checked: '2026-10-08',
    ingredients: 'Hemp Protein Powder.',
  },
  {
    brand: 'Body Fortress',
    name: 'Super Advanced Whey Protein',
    flavor: 'Chocolate',
    type: 'Whey',
    url: 'https://www.bodyfortress.com/products/100-whey-premium-protein-powder-chocolate',
    checked: '2026-10-08',
    ingredients: 'Super Whey Protein Blend (Whey Protein Concentrate, Whey Protein Isolate), Cocoa (Processed with Alkali), Maltodextrin, Lecithin, Natural Flavor, Salt, Cellulose Gum, Ascorbic Acid, Acesulfame Potassium, Sucralose, Zinc Oxide, Vitamin D3. Contains milk and soy ingredients.',
  },
  {
    brand: 'BPN',
    name: 'Whey Protein',
    flavor: 'Vanilla',
    type: 'Whey and casein',
    url: 'https://www.bareperformancenutrition.com/products/whey-protein-powder',
    checked: '2026-10-08',
    ingredients: 'Instantized Whey Protein Concentrate, Micellar Casein, Natural Flavor, Salt, Xanthan Gum, Steviol Glycosides (Rebaudioside M), Guar Gum, Monk Fruit Extract, Pink Himalayan Sea Salt. Contains: Milk and Soy.',
  },
  {
    brand: 'BSN',
    name: 'Syntha-6',
    flavor: 'Chocolate Milkshake',
    type: 'Whey and casein',
    url: 'https://www.gobsn.com/products/syntha-6-protein',
    checked: '2026-10-08',
    note: 'Transcribed from the nutrition label image there.',
    ingredients: 'Protein Matrix Comprised of (Whey Protein Concentrate, Calcium Caseinate, Hydrolyzed Whey Protein Concentrate, Whey Protein Isolate, Micellar Casein, Milk Protein Isolate), Polydextrose, Creamer (Sunflower Oil, Corn Syrup Solids, Sodium Caseinate, Mono- and Diglycerides, Dipotassium Phosphate, Tricalcium Phosphate, Soy Lecithin, Tocopherols), Cocoa Powder (Processed with Alkali), Natural and Artificial Flavor, MCT Powder (Medium Chain Triglycerides, Silicon Dioxide, Maltodextrin), Maltodextrin, Salt, Lecithin, Cellulose Gum, Acesulfame Potassium, Sucralose. Contains: Milk and Soy.',
  },
  {
    brand: 'Cantein',
    name: 'Organic Hemp Protein',
    flavor: 'Unflavored',
    type: 'Hemp',
    url: '/pages/our-ingredients',
    checked: '2026-10-08',
    ingredients: 'Organic hemp protein.',
  },
  {
    brand: 'Cantein',
    name: 'Organic Hemp Protein',
    flavor: 'Vanilla',
    type: 'Hemp',
    url: '/pages/our-ingredients',
    checked: '2026-10-08',
    ingredients: 'Organic hemp protein, organic MCT powder (from coconut), organic vanilla powder, organic flavor (from vanilla), organic monk fruit, salt.',
  },
  {
    brand: 'Cantein',
    name: 'Organic Hemp Protein',
    flavor: 'Chocolate',
    type: 'Hemp',
    url: '/pages/our-ingredients',
    checked: '2026-10-08',
    ingredients: 'Organic hemp protein, organic MCT powder (from coconut), organic cocoa powder, organic flavor (from cocoa), organic monk fruit, salt.',
  },
  {
    brand: 'Clean Simple Eats',
    name: 'Whey Protein Powder',
    flavor: 'Cookie Dough',
    type: 'Whey',
    url: 'https://cleansimpleeats.com/products/cookie-dough-protein-powder',
    checked: '2026-10-08',
    ingredients: 'Grass-Fed Whey Protein Isolate, Natural Flavors, Cocoa Powder, Sea Salt, Stevia Extract, Reb M (from Stevia Extract). Contains: Milk.',
  },
  {
    brand: 'Designer Protein',
    name: 'Designer Whey',
    flavor: 'French Vanilla',
    type: 'Whey and casein',
    url: 'https://designerwellness.com/products/designer-whey-french-vanilla-protein-powder-2-lb',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Designer Protein Blend (rBGH-free Whey Protein Concentrate, rBGH-free Micellar Casein, rBGH-free Whey Protein Isolate), Digestive Health Blend [GMO-free Prebiotic Vegetable Fiber, Probiotics (Lactobacillus Acidophilus, Bifidobacterium Longum, L. Plantarum), Vegetarian Protease Enzymes], 2% or less of the following: Natural Flavors, Xanthan Gum, Stevia Extract, Sea Salt, Sunflower Lecithin. Contains milk.',
  },
  {
    brand: 'Dymatize',
    name: 'ISO100 Hydrolyzed',
    flavor: 'Gourmet Vanilla',
    type: 'Whey',
    url: 'https://dymatize.com/products/iso100-gourmet-vanilla',
    checked: '2026-10-08',
    ingredients: 'HYDROLYZED WHEY PROTEIN ISOLATE, WHEY PROTEIN ISOLATE. LESS THAN 2% OF: NATURAL AND ARTIFICIAL FLAVOR, SALT, SOY LECITHIN, SUCRALOSE, STEVIOL GLYCOSIDES (STEVIA). CONTAINS: MILK AND SOY.',
  },
  {
    brand: 'Dymatize',
    name: 'ISO100 Hydrolyzed',
    flavor: 'Gourmet Chocolate',
    type: 'Whey',
    url: 'https://dymatize.com/products/iso100-gourmet-chocolate',
    checked: '2026-10-08',
    ingredients: 'HYDROLYZED WHEY PROTEIN ISOLATE, WHEY PROTEIN ISOLATE, COCOA POWDER (PROCESSED WITH ALKALI). LESS THAN 2% OF: SALT, SOY LECITHIN, NATURAL AND ARTIFICIAL FLAVOR, POTASSIUM CHLORIDE, SUCRALOSE, STEVIOL GLYCOSIDES (STEVIA). CONTAINS: MILK AND SOY.',
  },
  {
    brand: 'Dymatize',
    name: 'Elite 100% Whey',
    flavor: 'Gourmet Vanilla',
    type: 'Whey',
    url: 'https://dymatize.com/products/elite-100-whey-gourmet-vanilla',
    checked: '2026-10-08',
    ingredients: 'WHEY PROTEIN BLEND (WHEY PROTEIN CONCENTRATE, WHEY PROTEIN ISOLATE HYDROLYZED WHEY PROTEIN CONCENTRATE), LESS THAN 2% OF: NATURAL AND ARTIFICIAL FLAVORS, SOY LECITHIN, SUCRALOSE, ACESULFAME POTASSIUM. GUM BLEND (CELLULOSE GUM, XANTHAN GUM, CARRAGEENAN). CONTAINS: MILK AND SOY.',
  },
  {
    brand: 'Earth Fed Muscle',
    name: 'Whey Back',
    flavor: 'Vanilla',
    type: 'Whey',
    url: 'https://earthfedmuscle.com/products/whey-back-vanilla-protein',
    checked: '2026-10-08',
    ingredients: 'Truly Grass Fed Whey Protein Isolate, Organic Vanilla Flavor, Sunflower Lecithin, Organic Stevia. Contains: Dairy',
  },
  {
    brand: 'FlavCity',
    name: 'Protein Smoothie',
    flavor: 'Chocolate',
    type: 'Whey and collagen',
    url: 'https://www.shopflavcity.com/products/chocolate-protein-smoothie',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Whey Protein Concentrate (Grass-Fed, Undenatured), Collagen (Grass-Fed), Organic Cocoa Powder, Coconut Milk Powder, Milk Protein Concentrate (Grass-Fed), Fermented Nutritional Yeast Protein, Banana Powder, Unrefined Sea Salt, Organic Stevia Leaf Extract (Reb A), Stevia Leaf Extract (Reb M), Organic Cordyceps Powder, Organic Reishi Powder. Contains: Milk. Manufactured on shared equipment that may contain peanuts or other tree nuts.',
  },
  {
    brand: 'Four Sigmatic',
    name: 'Plant-Based Protein',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://us.foursigmatic.com/products/creamy-cacao-plant-based-protein',
    checked: '2026-10-08',
    note: 'Transcribed from the Supplement Facts image there: the four blends in the panel, then the "Other ingredients." Latin names are left out.',
    ingredients: 'Organic Protein Blend (Organic Brown Rice Protein, Organic Pea Protein, Organic Hemp Protein), Organic Mushroom Blend (Organic Turkey Tail Extract, Organic Lion\'s Mane Extract, Organic Reishi Extract), Organic Greens + Fruit Blend (Organic Moringa, Organic Kale, Organic Wheatgrass, Organic Beet Root Extract, Organic Blueberry), Digestive Blend (Organic Yacon Root Powder, Bacillus subtilis DE111), Organic Cacao Powder, Organic Coconut Milk Powder, Organic Coconut Palm Sugar, Himalayan Salt, Organic Monk Fruit Extract.',
  },
  {
    brand: 'Gainful',
    name: 'Performance Whey Protein',
    flavor: 'Unflavored',
    type: 'Whey',
    url: 'https://gainful.com/products/performance-whey-protein',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Concentrate, Whey Protein Isolate, Organic Tapioca Maltodextrin, CherryPURE Tart Cherry Powder, Sunflower Lecithin. Contains: Milk',
  },
  {
    brand: 'Garden of Life',
    name: 'Raw Organic Protein',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://www.gardenoflife.com/products/our-protein/raw-organic-protein-powder-vanilla',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'INGREDIENTS: Raw Organic Protein Blend: Organic Pea Protein, Organic Sprouted Brown Rice Protein, Organic Amaranth Sprout, Organic Buckwheat Sprout, Organic Millet Sprout, Organic Cracked Wall Chlorella, Organic Quinoa Sprout, Organic Chia Seed Sprout, Organic Garbanzo Bean Sprout, Organic Lentil Sprout, Organic Adzuki Bean Sprout, Organic Flax Seed Sprout, Organic Sunflower Seed Sprout, Organic Pumpkin Seed Sprout, Organic Sesame Seed Sprout, Organic Flavor Blend: Organic Vanilla Flavor with Other Natural Flavors, Organic Erythritol, Organic Guar Gum, Organic Stevia Leaf Extract, Sea Salt, Raw Probiotic & Enzyme Blend: Lipase, Protease, Aspergillopepsin, beta-Glucanase, Cellulase, Bromelain, Phytase, Lactase, Papain, Peptidase, Pectinase, Hemicellulase, Xylanase, Bacillus subtilis DE111® (250 million CFU at time of expiration). Contains: Sesame.',
  },
  {
    brand: 'Garden of Life',
    name: 'SPORT Certified Grass Fed Whey',
    flavor: 'Vanilla',
    type: 'Whey',
    url: 'https://www.gardenoflife.com/products/our-protein/sport-certified-grass-fed-whey-vanilla',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'INGREDIENTS: Truly Grass Fed Protein Blend (Whey Protein Isolate 85%, Milk Protein 15%), Organic Tapioca Fiber (IMO), Vanilla Flavor with Other Natural Flavors, Organic Gum Acacia, Sunflower Lecithin, Organic Stevia Extract (leaf), Sea Salt, Bifidobacterium lactis BL818 2 Billion CFU (at time of expiration). Contains: Milk.',
  },
  {
    brand: 'Ghost',
    name: 'Whey Protein',
    flavor: 'Chocolate Chip Cookies',
    type: 'Whey',
    url: 'https://www.ghostlifestyle.com/products/ghost-whey-chocolate-chip-cookies',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Ingredients: Whey Protein (Whey Protein Isolate, Whey Protein Concentrate, Hydrolyzed Whey Protein Isolate), Chocolate Chip Cookies (Gluten Free Flour Blend (Oat Flour, White Rice Flour, Cassava Flour, Sorghum Flour), Organic Cane Sugar, Sunflower Oil, Semi-sweet Chocolate Chips (Cane Sugar, Unsweetened Chocolate, Cocoa Butter), Water, Tapioca Starch, Tapioca Fiber Syrup, Baking Soda, Vanilla Extract, Sea Salt, Caramelized Cane Sugar, Xanthan Gum, Konjac Gum, Rosemary Extract), Natural and Artificial Flavors, Salt, Digestive Enzymes (Proteases, Bromelain, Lactase), Cellulose Gum, Xanthan Gum, Sucralose. Contains: Milk',
  },
  {
    brand: 'Gnarly',
    name: 'Grass-Fed Whey Protein',
    flavor: 'Chocolate',
    type: 'Whey',
    url: 'https://gognarly.com/products/grass-fed-whey-protein',
    checked: '2026-10-08',
    note: 'Gnarly lists whey and a digestive blend as active ingredients, then the other ingredients; they are combined here. The page does not say what is in the digestive blend or the coconut creamer.',
    ingredients: 'Whey Protein Concentrate, Digestive Blend, Cocoa Powder, Coconut Creamer, Natural Flavors, Sea Salt, Guar Gum, Stevia Leaf Extract, Calcium Silicate, Konjac Gum.',
  },
  {
    brand: 'Huel',
    name: 'Black Edition',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://huel.com/pages/black-ingredients',
    checked: '2026-10-08',
    note: 'Huel Black Edition is a meal shake, so the list includes added vitamins and minerals.',
    ingredients: 'Pea Protein, Ground Flaxseed, Brown Rice Protein, Tapioca Flour, Cocoa Powder (6.4%), Sunflower Oil Powder, Organic Coconut Sugar, Natural Flavors, Maltodextrin, Medium-Chain Triglyceride Powder (from Coconut), Xanthan Gum, Potassium Citrate, Potassium Chloride, Corn Starch, Calcium Carbonate, Sodium Chloride, Steviol Glycosides, Green Tea Extract Powder, Kombucha Powder, Ascorbic Acid, Bacillus Coagulans MTCC 5856, Niacinamide, Lutein, Calcium-D-Pantothenate, Lycopene, Pyridoxine Hydrochloride, Riboflavin, Retinyl Acetate, Thiamine Mononitrate, Zeaxanthin, Menaquinone-7, L-Methylfolate, Potassium Iodide, Vitamin D2, Plant-Derived Vitamin D3, Cyanocobalamin. Contains: Tree Nuts (Coconut).',
  },
  {
    brand: 'Isopure',
    name: 'Zero Carb Protein Powder',
    flavor: 'Creamy Vanilla',
    type: 'Whey',
    url: 'https://www.theisopurecompany.com/products/flavored-protein-powder',
    checked: '2026-10-08',
    note: 'Transcribed from the nutrition label image there.',
    ingredients: 'Whey Protein Isolate, Vitamin and Mineral Blend (Calcium Phosphate, Magnesium Oxide, Ascorbic Acid, Niacinamide, d-alpha Tocopheryl Acetate, Zinc Oxide, Silicon Dioxide, Calcium D-Pantothenate, Vitamin A Acetate, Potassium Iodide, Manganese Sulfate, Chromium Chloride, Copper Sulfate, Pyridoxine Hydrochloride, Riboflavin, Sodium Molybdate, Sodium Selenite, Thiamine Mononitrate, Folic Acid, Cyanocobalamin), Soy Lecithin, Natural and Artificial Flavor, Salt, Sucralose, Xanthan Gum. Contains: Milk and Soy.',
  },
  {
    brand: 'Jocko Fuel',
    name: 'Protein Powder',
    flavor: 'Chocolate Milkshake',
    type: 'Whey, casein and egg',
    url: 'https://jockofuel.com/products/jocko-protein-powder',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Jocko Protein Blend (Whey Protein Concentrate, Whey Protein Isolate, Micellar Casein, Egg White Protein), Alkalized Cocoa, Natural Flavors, Jocko GOOD Sweetener (Allulose, Reb-M, Monk Fruit Extract), Guar Gum, Acacia, Xanthan Gum, Sunflower Lecithin, Sea Salt, Potassium Chloride, L. Acidophilus, Prohydroxy (Amylase, Lactase, Lipase, Protease I, Protease II). Contains: Milk, Egg.',
  },
  {
    brand: 'KOS',
    name: 'Organic Plant Protein',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://kos.com/products/kos-organic-vegan-plant-based-protein-powder',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'INGREDIENTS: KOS® Organic Protein Blend (Pea Protein*, Flax Seed*, Quinoa*, Pumpkin Seed Protein*, Chia Seed*), KOS® Organic Superfoods Blend (Coconut Milk*, Inulin*, Acacia Gum*, Apple*, Carrot*, Cranberry*, Orange Juice*, Broccoli*, Shiitake Mushroom Extract*, Tomato*), Alkalized Cocoa*, Coconut Sugar*, Sea Salt, Natural Chocolate Flavor, Stevia Leaf Extract*, Monk Fruit Extract*, Vitamins and Minerals Blend (D-Alpha Tocopherol, Manganese Amino Acid Chelate, Potassium Iodide, Zinc Oxide, Vitamin A Palmitate, Selenium Amino Acid Chelate, Molybdenum Amino Acid Chelate, Niacinamide, Copper Oxide, Riboflavin, Cyanocobalamin, Folic Acid), Digestive Enzyme Blend (Proteases, Amylases, Cellulase, Lactase, Lipase). *Certified Organic Ingredients.',
  },
  {
    brand: 'Legion',
    name: 'Whey+',
    flavor: 'Dutch Chocolate',
    type: 'Whey',
    url: 'https://legionathletics.com/products/supplements/whey-protein-powder/',
    checked: '2026-10-08',
    note: 'These are the "Other ingredients" from the Supplement Facts image there. The panel itself lists 25g of grass-fed whey protein isolate.',
    ingredients: 'Whey Protein Isolate, Cocoa Powder (Alkali Processed), Natural Flavor, Xanthan Gum, Sunflower Lecithin, Sea Salt, Steviol Glycosides (derived from Stevia Extract, Tapioca Starch), Stevia Leaf Extract (Rebaudioside A). Contains: Milk.',
  },
  {
    brand: 'Manitoba Harvest',
    name: 'Complete Plant Protein Blend',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://manitobaharvest.com/products/complete-plant-protein-blend-chocolate',
    checked: '2026-10-08',
    ingredients: 'Pea Protein*, Hemp Seed Powder*, Coconut Sugar*, Cocoa processed with Alkali*, Natural Flavors, Guar Gum*, Monk Fruit Extract, Oregano Extract.',
  },
  {
    brand: 'Momentous',
    name: 'Grass-Fed Whey Protein Isolate',
    flavor: 'Vanilla',
    type: 'Whey',
    url: 'https://www.livemomentous.com/products/essential-whey-protein',
    checked: '2026-10-08',
    ingredients: 'Grass-fed whey protein isolate, ProHydrolase®, natural flavors, salt, monk fruit extract, stevia.',
  },
  {
    brand: 'Momentous',
    name: 'Grass-Fed Whey Protein Isolate',
    flavor: 'Unflavored',
    type: 'Whey',
    url: 'https://www.livemomentous.com/products/essential-whey-protein',
    checked: '2026-10-08',
    ingredients: 'Grass-fed whey protein isolate, ProHydrolase®.',
  },
  {
    brand: 'Momentous',
    name: '100% Plant Protein',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://www.livemomentous.com/products/100-plant-protein-powder',
    checked: '2026-10-08',
    ingredients: 'PURIS® Pea Protein, Organic Brown Rice Protein. Other Ingredients: Natural Vanilla Flavors, Organic Cane Sugar, Sea Salt, Reb M.',
  },
  {
    brand: 'MuscleTech',
    name: 'Nitro-Tech',
    flavor: 'Milk Chocolate',
    type: 'Whey',
    url: 'https://www.muscletech.com/products/nitro-tech',
    checked: '2026-10-08',
    note: 'These are the "Other ingredients." The Supplement Facts panel also lists 3g of creatine per serving.',
    ingredients: 'Premium Protein Blend (Whey Protein Concentrate, Whey Protein Isolate, Whey Peptides), Cocoa (Processed with Alkali), Soy and/or Sunflower Lecithin, Salt, Gum Blend (Cellulose Gum, Xanthan Gum, Carrageenan), Natural and Artificial Flavors, Enzyplex (Papain, Amylase), Sucralose, Acesulfame-Potassium. Contains milk and soy ingredients.',
  },
  {
    brand: 'Myprotein',
    name: 'Impact Whey Protein',
    flavor: 'Chocolate Milkshake',
    type: 'Whey',
    url: 'https://us.myprotein.com/p/sports-nutrition/impact-whey-protein/10852500/',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Concentrate (Whey Protein Concentrate, Sunflower Lecithin), Cocoa processed with Alkali, Natural and Artificial Flavoring (Natural and Artificial Flavor, Gum Arabic), Cellulose Gum, Sucralose, Acesulfame Potassium, Salt. Contains: Milk. Made in a facility that also handles Egg, Gluten and products thereof.',
  },
  {
    brand: 'Naked Nutrition',
    name: 'Naked Whey',
    flavor: 'Unflavored',
    type: 'Whey',
    url: 'https://nakednutrition.com/products/grass-fed-whey-protein-powder-2lb',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Concentrate. Contains: Milk.',
  },
  {
    brand: 'Naked Nutrition',
    name: 'Naked Whey',
    flavor: 'Vanilla',
    type: 'Whey',
    url: 'https://nakednutrition.com/products/vanilla-whey-protein-2lb',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Concentrate, Organic Coconut Sugar, Natural Flavor. Contains: Milk and Tree Nuts (Coconut Sugar).',
  },
  {
    brand: 'Naked Nutrition',
    name: 'Naked Whey Isolate',
    flavor: 'Vanilla',
    type: 'Whey',
    url: 'https://nakednutrition.com/products/vanilla-whey-isolate-protein-powder-2lb',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Isolate, Natural Vanilla Extract, Fermented Reb-M, and Sunflower Lecithin. Contains: Milk.',
  },
  {
    brand: 'Naked Nutrition',
    name: 'Naked Pea',
    flavor: 'Unflavored',
    type: 'Plant',
    url: 'https://nakednutrition.com/products/pea-protein-powder-2lb',
    checked: '2026-10-08',
    ingredients: 'Pea protein.',
  },
  {
    brand: 'Naked Nutrition',
    name: 'Naked Pea',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://nakednutrition.com/products/vanilla-pea-protein-powder-2lb',
    checked: '2026-10-08',
    ingredients: 'Yellow Pea Protein, Organic Coconut Sugar, Natural Vanilla Flavor. Contains: Tree Nuts (Coconut).',
  },
  {
    brand: 'NOW Sports',
    name: 'Whey Protein Isolate',
    flavor: 'Unflavored',
    type: 'Whey',
    url: 'https://www.nowfoods.com/products/sports-nutrition/whey-protein-isolate-unflavored-powder',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Isolate, Sunflower Lecithin (< 1%). Contains milk.',
  },
  {
    brand: 'Nutiva',
    name: 'Organic Hemp Protein',
    flavor: 'Unflavored',
    type: 'Hemp',
    url: 'https://www.nutiva.com/products/organic-hemp-protein-powder',
    checked: '2026-10-08',
    ingredients: 'Organic Hemp Seed Protein.',
  },
  {
    brand: 'Nutricost',
    name: 'Whey Protein Isolate',
    flavor: 'Milk Chocolate',
    type: 'Whey',
    url: 'https://nutricost.com/products/nutricost-whey-protein-isolate-powder-5-lbs',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Whey protein isolate (whey protein, sunflower lecithin) (instantized), cocoa powder (processed with alkali), natural and artificial flavors, salt (sodium chloride), acesulfame potassium, sucralose. Contains: Milk.',
  },
  {
    brand: 'Optimum Nutrition',
    name: 'Gold Standard 100% Whey',
    flavor: 'Double Rich Chocolate',
    type: 'Whey',
    url: 'https://www.optimumnutrition.com/en-us/products/gold-standard-100-whey-protein-powder',
    checked: '2026-10-08',
    note: 'Transcribed from the US label photo there.',
    ingredients: 'INGREDIENTS: Protein Blend (Whey Protein Isolate, Whey Protein Concentrate, Hydrolyzed Whey Protein), Cocoa Powder (Processed with Alkali), Sunflower and/or Soy Lecithin, Natural and Artificial Flavor, Acesulfame Potassium. CONTAINS: MILK, SOY.',
  },
  {
    brand: 'Ora',
    name: 'So Lean & So Clean Organic Protein',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://ora.organic/products/organic-protein-powder',
    checked: '2026-10-08',
    note: 'Ora\'s page groups these by purpose (protein, superfoods, enzymes, flavor), so the order here may not be the label order.',
    ingredients: 'Organic Pea Protein, Organic Rice Protein, Organic Cranberry, Organic Sacha Inchi, Organic Sprouted Quinoa, Organic Amaranth, Organic Acerola Extract, Organic Blackberry, Organic Blueberry, Organic Pomegranate, Organic Turmeric, Organic Strawberry, Organic Apple, Organic Acai, Organic Kale, Organic Broccoli, Amylase, Neutral Protease, Lactase, Lipase, Cellulase, Organic Coconut Milk, Organic Jerusalem Artichoke Inulin, Organic Cocoa Powder, Natural Dark Chocolate Flavor, Organic Monk Fruit Extract.',
  },
  {
    brand: 'Orgain',
    name: 'Organic Protein Plant Based',
    flavor: 'Vanilla Bean',
    type: 'Plant',
    url: 'https://orgain.com/products/organic-protein-plant-based-protein-powder-vanilla-bean',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'ORGAIN ORGANIC PROTEIN BLEND™ (ORGANIC PEA PROTEIN, ORGANIC BROWN RICE PROTEIN, ORGANIC MUNG BEAN PROTEIN, ORGANIC CHIA SEED), ORGANIC NATURAL FLAVORS, ORGAIN CREAMER BASE™ (ORGANIC ACACIA, ORGANIC HIGH OLEIC SUNFLOWER OIL, ORGANIC RICE DEXTRIN, SUNFLOWER LECITHIN, ORGANIC ROSEMARY EXTRACT), ORGANIC AGAVE INULIN FIBER, ORGANIC REB A (STEVIA EXTRACT), SEA SALT, ORGANIC ACACIA, ORGANIC GUAR GUM, XANTHAN GUM.',
  },
  {
    brand: 'Orgain',
    name: 'Simple Organic Plant-Based',
    flavor: 'Creamy Vanilla',
    type: 'Plant',
    url: 'https://orgain.com/products/simple-organic-plant-based-protein-powder-creamy-vanilla',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'ORGAIN ORGANIC PROTEIN BLEND™ (ORGANIC PEA PROTEIN, ORGANIC BROWN RICE PROTEIN, ORGANIC ROASTED PEANUT FLOUR, ORGANIC PUMPKIN SEED PROTEIN, ORGANIC ALMOND PROTEIN, ORGANIC CHIA SEED), ORGANIC COCONUT SUGAR, ORGANIC NATURAL FLAVORS, SEA SALT. CONTAINS: PEANUTS, TREE NUTS (ALMONDS, COCONUT)',
  },
  {
    brand: 'OWYN',
    name: 'Plant Protein Powder',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://liveowyn.com/products/chocolate-protein-powder-2-lbs',
    checked: '2026-10-08',
    note: 'The BCAA amounts OWYN prints after its protein blend are left out here.',
    ingredients: 'OWYN Protein Blend (pea protein concentrate, pumpkin protein, chia), organic cane sugar, cocoa, natural flavors, sea salt, xanthan gum, monk fruit extract, silica, Superfoods & Greens Blend (kale, spinach, broccoli), mineralized seaweed, Bacillus coagulans MTCC5856 (1 mg) (10 million CFU), flaxseed.',
  },
  {
    brand: 'PEScience',
    name: 'Select Protein',
    flavor: 'Gourmet Vanilla',
    type: 'Whey and casein',
    url: 'https://pescience.com/products/select-protein',
    checked: '2026-10-08',
    ingredients: 'Select Protein Blend (Milk Protein Isolate [comprised of casein protein and whey protein], Whey Protein Concentrate 80%, Leucine Peptides), Sodium Chloride, Natural And Artificial Flavors, Guar Gum, Sucralose, Acesulfame Potassium. Contains milk and soy (lecithin) ingredients.',
  },
  {
    brand: 'Premier Protein',
    name: '100% Whey Protein Powder',
    flavor: 'Vanilla Milkshake',
    type: 'Whey',
    url: 'https://www.premierprotein.com/products/vanilla-milkshake-protein-powder',
    checked: '2026-10-08',
    ingredients: 'WHEY PROTEIN ISOLATE, WHEY PROTEIN CONCENTRATE, CONTAINS 2 % OR LESS OF SOLUBLE CORN FIBER, SUNFLOWER LECITHIN, NATURAL AND ARTIFICIAL FLAVORS, ACESULFAME POTASSIUM, SUCRALOSE, XANTHAN GUM, SALT. CONTAINS: MILK.',
  },
  {
    brand: 'Premier Protein',
    name: '100% Whey Protein Powder',
    flavor: 'Chocolate Milkshake',
    type: 'Whey',
    url: 'https://www.premierprotein.com/products/chocolate-milkshake-protein-powder',
    checked: '2026-10-08',
    ingredients: 'WHEY PROTEIN ISOLATE, WHEY PROTEIN CONCENTRATE, COCOA PROCESSED WITH ALKALI, CONTAINS 2 % OR LESS OF SOLUBLE CORN FIBER, SUNFLOWER LECITHIN, NATURAL AND ARTIFICIAL FLAVORS, ACESULFAME POTASSIUM, SUCRALOSE, XANTHAN GUM, SALT. CONTAINS: MILK.',
  },
  {
    brand: 'Promix',
    name: 'Vegan Protein Powder',
    flavor: 'French Vanilla',
    type: 'Plant',
    url: 'https://www.promixnutrition.com/products/french-vanilla-vegan-protein-powder',
    checked: '2026-10-02',
    ingredients: 'Organic Canadian yellow pea protein isolate, organic vanilla extractives, monk fruit, vitamin B12.',
  },
  {
    brand: 'Quest',
    name: 'Protein Powder',
    flavor: 'Salted Caramel',
    type: 'Whey and casein',
    url: 'https://www.questnutrition.com/products/salted-caramel-protein-powder',
    checked: '2026-10-08',
    note: 'Quest marks molasses and sugar as adding a trivial amount of added sugars.',
    ingredients: 'INGREDIENTS: PROTEIN BLEND (WHEY PROTEIN ISOLATE, MICELLAR CASEIN), NATURAL FLAVORS. CONTAINS LESS THAN 2% OF THE FOLLOWING: SEA SALT, LECITHIN (SUNFLOWER, CANOLA, AND/OR SOY LECITHIN), CELLULOSE GUM, XANTHAN GUM, SILICON DIOXIDE, SUCRALOSE, STEVIA SWEETENER, MOLASSES, SUGAR. CONTAINS: MILK, SOY. PROCESSED IN A FACILITY THAT ALSO PROCESSES EGGS, PEANUTS, SESAME, WHEAT, TREE NUTS AND FISH.',
  },
  {
    brand: 'Ritual',
    name: 'Essential Protein Daily Shake 18+',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://ritual.com/products/essential-protein-daily-shake-18',
    checked: '2026-10-08',
    note: 'This is the ingredient list. Ritual also lists L-methionine and choline in its Supplement Facts panel.',
    ingredients: 'Organic pea protein, natural flavor, xanthan gum, coconut medium-chain triglyceride (MCT) oil, salt, sunflower lecithin, rebaudioside-m, mixed tocopherols, monk fruit (luo han guo) extract.',
  },
  {
    brand: 'Rule One',
    name: 'R1 Protein Whey Isolate',
    flavor: 'Chocolate Fudge',
    type: 'Whey',
    url: 'https://www.ruleoneproteins.com/products/r1-protein-whey-isolate',
    checked: '2026-10-08',
    note: 'Transcribed from the nutrition label image there.',
    ingredients: 'Protein Blend (Whey Protein Isolate, Hydrolyzed Whey Protein Isolate), Cocoa (Processed with Alkali), Contains 2% or Less of Natural and Artificial Flavors, Sucralose, Salt, Acesulfame Potassium, Soy Lecithin, Sunflower Lecithin. Contains: Milk & Soy.',
  },
  {
    brand: 'Six Star',
    name: '100% Whey Protein Plus',
    flavor: 'Triple Chocolate',
    type: 'Whey',
    url: 'https://www.sixstarpro.com/products/100-whey-protein-plus',
    checked: '2026-10-08',
    ingredients: 'Whey Protein Plus Blend (Whey Protein Concentrate, Whey Protein Isolate, Hydrolyzed Whey Protein), Maltodextrin, Cocoa (Processed with Alkali), Natural and Artificial Flavors, Soy and/or Sunflower Lecithin, Calcium Carbonate, Salt, Gum Blend (Guar Gum, Gum Acacia, Xanthan Gum), Sucralose, Ascorbic Acid, Zinc Oxide. Contains milk and soy ingredients.',
  },
  {
    brand: 'Sprout Living',
    name: 'Epic Protein',
    flavor: 'Original (Unflavored)',
    type: 'Plant',
    url: 'https://sproutliving.com/products/organic-plant-protein-prebiotics-unsweetened-unflavored-3',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Epic Protein Base (Organic Yellow Pea, Organic Pumpkin Seed, Organic Sunflower Seed, Organic Cranberry Seed, Organic Chia Seed), Organic Jerusalem Artichoke Inulin Fiber.',
  },
  {
    brand: 'Sunwarrior',
    name: 'Warrior Blend Organic Protein',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://sunwarrior.com/products/organic-warrior-blend-vegan-protein-powder',
    checked: '2026-10-08',
    ingredients: 'Proprietary Protein Blend (Organic Fermented Pea Protein, Organic Goji Berry, Organic Hemp Seed Protein), Organic Vanilla Flavor, Organic Guar Gum, Organic Medium-chain Triglycerides Oil (Coconut Oil, Acacia Gum), Sea Salt, Organic Stevia Leaf Extract (Steviol Glycosides).',
  },
  {
    brand: 'Thorne',
    name: 'Whey Protein Isolate',
    flavor: 'Vanilla',
    type: 'Whey',
    url: 'https://www.thorne.com/products/dp/whey-protein-isolate-vanilla',
    checked: '2026-10-08',
    note: 'Thorne lists whey isolate and a bromelain and papain blend in its ingredient amounts, then the other ingredients; they are combined here.',
    ingredients: 'Whey Protein Isolate, Bromelain and Papain Blend, Carboxymethylcellulose Gum, Xanthan Gum, Vanilla Flavor, Evaporated Cane Juice Sugar, Rebaudioside A (from stevia).',
  },
  {
    brand: 'Transparent Labs',
    name: 'Grass-Fed Whey Protein Isolate',
    flavor: 'Milk Chocolate',
    type: 'Whey',
    url: 'https://www.transparentlabs.com/products/whey-protein-isolate',
    checked: '2026-10-08',
    note: 'Transcribed from the label photo there.',
    ingredients: 'Grass-Fed Whey Protein Isolate (33g), Cocoa Powder (960mg), Natural Flavors (480mg), Salt (240mg), Stevia Extract (165mg), Sunflower Lecithin (99mg). Contains: Milk',
  },
  {
    brand: 'Truvani',
    name: 'Plant Based Protein',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://shop.truvani.com/pages/plant-based-protein/vanilla',
    checked: '2026-10-08',
    ingredients: 'Organic Pea Protein, Organic Vanilla Powder, Organic Pumpkin Seed, Organic Monk Fruit Extract, Organic Chia Seed Protein.',
  },
  {
    brand: 'Truvani',
    name: 'Plant Based Protein',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://shop.truvani.com/pages/plant-based-protein/vanilla',
    checked: '2026-10-08',
    ingredients: 'Organic Pea Protein, Organic Alkalized Cocoa, Organic Vanilla Powder, Organic Pumpkin Seed, Organic Monk Fruit Extract, Organic Chia Seed Protein.',
  },
  {
    brand: 'Truvani',
    name: 'Plant Based Protein',
    flavor: 'Unflavored & Unsweetened',
    type: 'Plant',
    url: 'https://shop.truvani.com/pages/plant-based-protein/unflavored-unsweetened',
    checked: '2026-10-08',
    ingredients: 'Organic Pea Protein, Organic Pumpkin Seed, Organic Chia Seed Protein.',
  },
  {
    brand: 'Vega',
    name: 'Protein Made Simple',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://myvega.com/products/vega-protein-made-simple',
    checked: '2026-10-08',
    ingredients: 'Pea Protein, Organic Cane Sugar, Coconut Cream Powder, Natural Flavors. Contains: Coconut. Manufactured in a facility that also processes milk, soy, peanuts, eggs, tree nuts, and sesame. May contain traces of soy due to agricultural practices.',
  },
  {
    brand: 'Vega',
    name: 'Protein Made Simple',
    flavor: 'Dark Chocolate',
    type: 'Plant',
    url: 'https://myvega.com/products/vega-protein-made-simple',
    checked: '2026-10-08',
    ingredients: 'Pea Protein, Organic Cane Sugar, Cocoa Powder (Processed With Alkali), Coconut Cream Powder, Natural Flavors. Contains: Coconut. Manufactured in a facility that also processes milk, soy, peanuts, eggs, tree nuts, and sesame. May contain traces of soy due to agricultural practices.',
  },
  {
    brand: 'Vega',
    name: 'Performance Protein + Recovery',
    flavor: 'Vanilla',
    type: 'Plant',
    url: 'https://myvega.com/products/vega-protein-recovery-premium-protein',
    checked: '2026-10-08',
    note: 'These are the "Other ingredients." Anything in the Supplement Facts panel is listed separately on the tub.',
    ingredients: 'Plant Protein Blend (Pea Protein, Pumpkin Seed Protein, Organic Sunflower Seed Protein) Natural Flavors, Stevia Leaf Extract, Sea Salt, Xanthan Gum. Manufactured in a facility that also processes milk, soy, peanuts, eggs, tree nuts, and sesame. May contain traces of soy due to agricultural practices.',
  },
  {
    brand: 'Vega',
    name: 'Performance Protein + Recovery',
    flavor: 'Chocolate',
    type: 'Plant',
    url: 'https://myvega.com/products/vega-protein-recovery-premium-protein',
    checked: '2026-10-08',
    note: 'These are the "Other ingredients." Anything in the Supplement Facts panel is listed separately on the tub.',
    ingredients: 'Plant Protein Blend (Pea Protein, Pumpkin Seed Protein, Organic Sunflower Seed Protein), Cocoa Powder (Processed With Alkali), Natural Flavors, Stevia Leaf Extract, Sea Salt, Xanthan Gum. Manufactured in a facility that also processes milk, soy, peanuts, eggs, tree nuts, and sesame. May contain traces of soy due to agricultural practices.',
  },
  {
    brand: 'Vital Proteins',
    name: 'Collagen Peptides',
    flavor: 'Unflavored',
    type: 'Collagen',
    url: 'https://www.vitalproteins.com/products/vp-collagen-peptides',
    checked: '2026-10-08',
    ingredients: 'Collagen Peptides (from bovine).',
  },
];
